//methods for sites with several steps/forms are stored here
export const multiFormMixin = {
  computed: {
    currentStep() {
      return this.steps[this.activeStep]
    },

    isLastStep() {
      return this.activeStep === this.steps.length - 1
    }
  },

  methods: {
    nextStep(setConfirmValues = undefined) {
      this.activeStep++
      this.currentStepper++
      this.disabledStepperItems[this.activeStep] = false

      if (this.isLastStep && setConfirmValues !== undefined) {
        setConfirmValues()
      }
    },

    previousStep() {
      this.activeStep--
      this.currentStepper--
    },

    setStepperItem(step, setConfirmValues = undefined) {
      this.currentStepper = step
      this.activeStep = step - 1

      if (this.isLastStep && setConfirmValues !== undefined) {
        setConfirmValues()
      }
    }
  }
}
